<template>
	<div class="modal inmodal fade modal-v5" tabindex="-1" role="dialog" id="modalDomainNS">
		<div class="modal-dialog modal-md" role="document">
			<div class="modal-content" v-if="!loading">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <h2 class="modal-title" v-text="translations.title"></h2>
                    <p v-if="!showStepByStep" class="modal-subtitle" v-text="translations.line_1"></p>
                </div>
                <div :class="['modal-body', domain != 'yourbuilderalldomain.com' ? 'padding-top-0' : '']">
                    <div class="form-group name-server-group">
                        <div v-if="domain != 'yourbuilderalldomain.com'" class="connected-domain">
                            <label v-text="`${translations.domain_connected}: `"> </label> <a :href="`https://${domain}`" target="_blank">{{domain}}</a><br><br>
                        </div>
                        <div v-if="!showStepByStep" class="cards">
                            <div v-for="card,i in infos" :key="i" class="card-content">
                                <b class="card-content-span" v-html="i+1"></b>
                                <p class="card-content-p" v-html="card"></p>
                            </div>
                        </div>
                        <div v-else>
                            <div @click.prevent="toogleStepByStep = !toogleStepByStep" :class="['open-ip', toogleStepByStep ? 'border-radius-open' : '']">
                                <button id="openIp" @click.prevent="toogleStepByStep = !toogleStepByStep" :class="['btn-open-ip', toogleStepByStep ? 'rotateOpen' : 'rotateClose']">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </button>
                                <b class="label-btn-open-ip" for="openIp" v-text="translations.step_by_step_name_servers"></b>
                            </div>
                            <div class="box-name-server-btn ip" v-if="toogleStepByStep">
                                <div class="name-server">
                                    <div class="cards">
                                        <div v-for="card,i in infos" :key="i" class="card-content">
                                            <b class="card-content-span" v-html="i+1"></b>
                                            <p class="card-content-p" v-html="card"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div class="box-name-server-btn">
                            <div class="name-server">
                                <div class="name-server-box">
                                    <label v-text="translations.ns_1"></label>
                                    <div class="name-server-input" @click="copy(ns1, 'ns1')">
                                        <input type="text" :value="ns1" :id="ns1"  @click="copy(ns1, 'ns1')" readonly>
                                        <img v-if="!this.showSuccessIcon['ns1']" src="/internacional/public/office5/img/franchise_dashboard/svg/copy-content.svg">
                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                        </svg>
                                    </div>
                                </div>
                                <div class="name-server-box">
                                    <label v-text="translations.ns_2"></label>
                                    <div class="name-server-input" @click="copy(ns2, 'ns2')">
                                        <input type="text" :value="ns2" :id="ns2"  @click="copy(ns2, 'ns2')" readonly>
                                        <img v-if="!this.showSuccessIcon['ns2']" src="/internacional/public/office5/img/franchise_dashboard/svg/copy-content.svg">
                                        <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                        </svg>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br>
                        <div>
                            <div @click="toogleIpBox()" :class="['open-ip', showIP ? 'border-radius-open' : '']">
                                <button id="openIp" @click="toogleIpBox()" :class="['btn-open-ip', showIP ? 'rotateOpen' : 'rotateClose']">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                                    </svg>
                                </button>
                                <b class="label-btn-open-ip" for="openIp" v-text="translations.ip_adresses"></b>
                            </div>
                            <div class="box-name-server-btn ip" v-if="showIP">
                                <div class="name-server">
                                    <div class="name-server-box">
                                        <label v-text="translations.ip_1"></label>
                                        <div class="name-server-input ip-input" @click="copy(ip1, 'ip1')">
                                            <input type="text" :value="ip1" :id="ip1"  @click="copy(ip1, 'ip1')" readonly>
                                            <img v-if="!this.showSuccessIcon['ip1']" src="/internacional/public/office5/img/franchise_dashboard/svg/copy-content.svg">
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                            </svg>
                                        </div>
                                    </div>
                                    <div class="name-server-box">
                                        <label v-text="translations.ip_2"></label>
                                        <div class="name-server-input ip-input" @click="copy(ip2, 'ip2')">
                                            <input type="text" :value="ip2" :id="ip2"  @click="copy(ip2, 'ip2')" readonly>
                                            <img v-if="!this.showSuccessIcon['ip2']" src="/internacional/public/office5/img/franchise_dashboard/svg/copy-content.svg">
                                            <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check-circle" viewBox="0 0 16 16">
                                                <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                                <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
			<div class="modal-content" v-else>
                <div class="modal-header">
                     <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    <br>
                </div>
                <div class="modal-body text-center">
                    <img class="modal-loader" src="/internacional/public/office4/img/dashboard/load-2.svg"/>
                </div>
            </div>
		</div>
	</div>
</template>

<script>
import qs from "qs";
export default {
    props: { 
        domain: String ,
        translations: Object,
        showIP: false,
    },
    data() {
        return {
            loadingRequest: false,
            showStepByStep: false,
            toogleStepByStep: true,
            showSuccessIcon: { 
                'ns1': false,
                'ns2': false,
                'ip1': false,
                'ip2': false,
            },
            ns1: '---',
            ns2: '---',
            ip1: '---',
            ip2: '---',
            lang: window.lang || 'us',
            infos: [this.translations.line_2.replace('-', ''),this.translations.line_3.replace('-', ''),this.translations.line_4.replace('-', '')]
        };
    },
    methods:{
        initialize(){
            this.requetsNs();
        },

        close(){
            $('#modalDomainNS').modal('hide');
        },
        copy(text,data){
            this.showSuccessIcon[data] = true;
            setTimeout(() => {this.showSuccessIcon[data] = false;}, 2000);
            let input = document.getElementById(text);
            input.select();
            document.execCommand('copy');
            alertMsg("success", this.translations.copied);
        },
        toogleIpBox(){
            this.showIP = !this.showIP;
        },
        resizeWindow()
        {
            console.log('resize');
            if($(window).width() < 830)
            {
                console.log('showStepByStep: ', this.showStepByStep);
                this.showStepByStep = true;
            }
            else
            {
                this.showStepByStep = false;
            }
        },
        requetsNs(){
            let vm = this;

            vm.loadingRequest = true;

            axios
            .get( `/${vm.lang}/office/get-domain-ns?domain=${vm.domain}`)
            .then(function(response) {
                if(response.data.success){
                    vm.ns1 = response.data.ns_servers.server_1;
                    vm.ns2 = response.data.ns_servers.server_2;
                    vm.ip1 = response.data.ip_addresses.ip_1;
                    vm.ip2 = response.data.ip_addresses.ip_2;
                }
            })
            .catch(function(error) {
                console.log('error', error);
            })
            .finally(function() {
                vm.loadingRequest = false
            });
        }
    },
    mounted(){
        this.initialize();
        let vm = this;
        $(window).resize(function(){
            vm.resizeWindow();
        });
    },
    computed: {
        loading() {
            return this.loadingRequest;
        },
    },
}
</script>


<style scoped lang="scss">
    .close{
        color: #C4C4C4 !important;
    }
    .modal-title{
        text-align: left !important;
        padding-left: 1em;
        color: #A5B9D5 !important;
        font-size: 1.8em !important;
        font-family: Lato;
        text-transform: uppercase;
    }
    .modal-subtitle{
        text-align: left;
        font-family: 'Lato';
        background: #E9EDF2;
        border-radius: 5px;
        color:#A5B9D5 !important;
        padding: 0.5em 1em;
        margin: 1em 2em 0em 2em;
    }
    .padding-top-0{
        padding-top: 0 !important;
    }
    .modal-body {
        .form-group{
            span {
                font-size: 15px;
                padding-top: 5px;
                padding-left: 5px;
            }
            .connected-domain{
                margin-bottom: .8em;
            }
        }
        .modal-loader{
            width: 100px;
        }
        .cards{
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            gap: 2%;
            justify-content: space-between;
            .card-content {
                background: red;
                width: 30%;
                background: #E9EDF2;
                padding: 1em 1em 0.5em 1em;
                border-radius: 0.5em;
                display: flex;
                flex-direction: column;
                align-items: center;
                .card-content-span{
                    margin-top: -2.3em;
                    background: #0080FC;
                    padding: 0.7em;
                    color: #fff;
                    width: 2.5em;
                    border-radius: 50%;
                    display: flex;
                    justify-content: center;
                }
                .card-content-p{
                    margin: 1em !important;
                    text-align: center;
                    font-size: .85em;
                }
            }
        }
        .ip{
            background: transparent !important;
            border-radius: 0 0 1em 1em !important;
            border: 1px solid #C9E4FF !important;
        }
        .box-name-server-btn{
            padding: 1em;
            background: #E9EDF2;
            border-radius: 0.5em;
            .name-server {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                justify-content: space-between;
                .name-server-box {
                    width: 47%;
                    .ip-input{
                        border: 0.5px solid #A5B9D5 !important;
                    }
                    .name-server-input{
                        width: 100%;
                        text-align: center;
                        color: #A5B9D5;
                        cursor: pointer;
                        background: #fff;
                        border-radius: 0.7em;
                        display: flex;
                        justify-content: center;
                        cursor: pointer;
                        align-items: center;
                        gap: 8%;
                        input{
                            border: none;
                            background: transparent;
                            width: 50%;
                            text-align: center;
                            cursor: pointer;
                            outline: none;
                            color: #A5B9D5;
                        }
                        svg{
                            color: #02EAA0;
                            animation-name: svgSuccess;
                            animation-duration: 1s;
                        }
                        img{
                            width: 5%;
                        }
                    }
                }
            }
        }
        label{
            font-weight: bold !important;
        }
        .copy__icon{
            cursor: pointer !important;
            padding: 10px !important;
        }
        .border-radius-open{
            border-radius: 0.5em 0.5em 0 0 !important;
            border-bottom: none !important;
        }
        .open-ip{
            border: 1px solid #C9E4FF;
            padding: 1em;
            border-radius: 0.5em;
            align-items: center;
            display: flex;
            flex-direction: row;
            gap: 1%;
            align-items: center;
            cursor: pointer;
            svg{
                margin-top: 0.23em;
            }
            .btn-open-ip{
                transition: .8s;
                border: none;
                outline: none;
                background: transparent;
            }
            .btn-open-ip{
                color: #A5B9D5;
            }
            .label-btn-open-ip{
                color: #0080FC !important;
            }
            .rotateOpen{
                transform: rotate(180deg);
            }
            .rotateClose{
                transform: rotate(0deg);
            }
        }
    }
    @media only screen and (max-width: 830px) {
        .modal-body {
            padding: 0;
            .box-name-server-btn{
                padding: 2em 0.5em 0.5em 0.5em;
            }
            .cards{
                flex-direction: column;
                .card-content {
                    width: 100%;
                    margin-bottom: 2em;
                }
            }
        }
    }
    @media only screen and (max-width: 780px) {
        .modal-title{
            font-size: 1.3em !important;
            padding-left: 0 !important;
        }
        .modal-body {
            .box-name-server-btn{
                .name-server {
                    flex-direction: column;
                    .name-server-box {
                        width: 100%;
                        .name-server-input{
                            margin-bottom: 1em;
                            input{
                                width: 70%;
                                font-size: .9em;
                            }
                        }
                    }
                }
            }
        }
    }
    @media only screen and (max-width: 410px) {
        .modal-body {
            .box-name-server-btn{
                .name-server {
                    .name-server-box {
                        .name-server-input{
                            img{
                                width: 7%;
                            }
                        }
                    }
                }
            }
        }
    }
    @keyframes svgSuccess {
        from {transform: rotate(0deg);}
        to {transform: rotate(360deg);}
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/domains-storage/domainNS.vue